import fetch from 'isomorphic-fetch';
import { API2_URL, STATUS_FAIL, STATUS_FETCH, STATUS_REQUEST, STATUS_GROUP } from "../store/config";
import { newNotification } from "./notifications";
import _ from "lodash";
import {sessionService} from "redux-react-session";

export const statusList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(statusRequest());
				return fetch(`${API2_URL}/status?include[0]=groups&group_id=1`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(statusDetails(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: _.values(error), type: "danger"}));
							return dispatch(statusFailed(_.values(error)));
						}
					);
			})
	}
}

export const statusGroupList = (group = 1) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(statusRequest());
				return fetch(`${API2_URL}/status?group_id=${group}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(statusGroup(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: _.values(error), type: "danger"}));
							return dispatch(statusFailed(_.values(error)));
						}
					);
			})
	}
}

export const statusMotivesList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(statusRequest());
				return fetch(`${API2_URL}/status/groups?include[0]=statuses.motives`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(statusDetails(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: _.values(error), type: "danger"}));
							return dispatch(statusFailed(_.values(error)));
						}
					);
			})
	}
}

export const statusActivitiesList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(statusRequest());
				return fetch(`${API2_URL}/status/groups?slug=activities&include[0]=statuses.motives`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(statusDetails(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: _.values(error), type: "danger"}));
							return dispatch(statusFailed(_.values(error)));
						}
					);
			})
	}
}

export const statusRequest = () => {
	return {
		type: STATUS_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

export const statusDetails = (json) => {
	return {
		type: STATUS_FETCH,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
}

export const statusFailed = (error) => {
	return {
		type: STATUS_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

export const statusGroup = (json) => {
	return {
		type: STATUS_GROUP,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/status.js